import * as DateF from 'date-fns'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Tooltip } from '@blade/ui-kit'
import { usePairAgeFormatted, type Pair } from '@root/entities/pair'
import { PairLink } from '@root/entities/pair/ui/common'
import { DATE_FORMAT } from '@root/shared'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps

export const CreatorPairsTableCreatedCell: React.FC<Props> = ({ pair }) => {
  const { t } = useTranslation()
  const { formatted: pairAge } = usePairAgeFormatted(pair.createdAt)

  const renderTooltipContent = () => {
    if (!pair.createdAt) {
      return undefined
    }
    return DateF.format(pair.createdAt, DATE_FORMAT.HH_mm__dd_MM_yy)
  }

  return (
    <Tooltip content={renderTooltipContent()}>
      <Root pair={pair}>{pairAge || t('common.n_a')}</Root>
    </Tooltip>
  )
}

const Root = styled(PairLink<Pair.PairMinimal>)`
  pointer-events: auto;
  color: var(--text-11);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
